import { Component, OnInit, Input } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { AdminService } from '../../../../../services/core.admin.service';

@Component({
  selector: 'project-admin-homepage-header',
  template: require('./project.admin.homepage.header.html')
})
export class ProjectAdminHomepageHeaderComponent implements OnInit {
  @Input() project: any;
  @Input() isProjectAdmin: any;
  @Input() useCustomSplash: any;

  onOff: { [key: string]: string } = {};

  constructor(
    private stateService: StateService, 
    private adminService: AdminService
  ) {}

  ngOnInit(): void {
    this.onOff = { 'Standard': 'N', 'Custom': 'Y' };
  }

  homepageSettingCallback(optionValue: string): void {
    if (optionValue?.length > 0) {
      this.useCustomSplash = optionValue;
      this.adminService.postConfig({
        settingName: 'useCustomSplash',
        section: 'project',
        refId: this.project.id,
        settingValue: optionValue
      }).then(() => {
        this.stateService.reload();
      }).catch(response => {
        console.log(response);
      });
    }
  }

  isCustomSplashEnabled(): boolean {
    return this.useCustomSplash === 'Y'
      || this.useCustomSplash === 'y'
      || this.useCustomSplash === true
      || this.useCustomSplash === 'true'
      || this.useCustomSplash === 1
      || this.useCustomSplash === '1';
  }
}
